export default __webpack_public_path__ + "static/media/213.657edd58.jpg";